module.exports = __webpack_public_path__ + "d664201f/img/file-icon.c085e21e.svg";